import { classes } from 'html-classes';
import React from 'react';
import Skeleton from 'react-loading-skeleton';

import styles from './PromocodesSkeleton.module.scss';

export const PromocodesSkeleton: React.FC<
  Omit<React.ComponentPropsWithoutRef<'div'>, 'children'>
> = ({ className, ...props }) => (
  <div {...props} className={classes([styles.promocodesSkeleton, className])}>
    <Skeleton className={styles.bannerSkeleton} />
    <div className={styles.tabs}>
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton key={index} height={12} />
      ))}
    </div>
    <div className={styles.cards}>
      <PromocodesCardsSkeleton />
    </div>
  </div>
);

export const PromocodesCardsSkeleton: React.FC = () => (
  <>
    {Array.from({ length: 4 }).map((_, index) => (
      <div key={index} className={styles.card}>
        <Skeleton height={64} width={64} />
        <div className={styles.cardContent}>
          <Skeleton height={12} width={123} inline={false} />
          <Skeleton height={7} width={'100%'} inline={false} />
          <Skeleton height={40} width={'100%'} inline={false} />
        </div>
      </div>
    ))}
  </>
);
